import { useMutation, useQueryClient } from "@tanstack/react-query";
import { runCompassActions, reorderActions } from "../services/compass.service";
import {
  ICompasAIActionsRequest,
  IActionRunResponse,
  IReorderActionsRequest,
  IReorderActionsResponse,
} from "../types/compass.types";

/**
 * Hook to run compass actions (single or bulk)
 */
export const useRunCompassActions = () => {
  const queryClient = useQueryClient();

  return useMutation<
    IActionRunResponse,
    Error,
    { requests: ICompasAIActionsRequest | ICompasAIActionsRequest[]; documentId: string }
  >({
    mutationFn: ({ requests }) => runCompassActions(requests),
    onSuccess: (_, variables) => {
      // Invalidate compass chat history to reflect updated statuses
      queryClient.invalidateQueries({
        queryKey: ["compass-chat-history", variables.documentId],
      });
    },
    onError: (error) => {
      console.error("Failed to run compass actions:", error);
    },
  });
};

/**
 * Hook to reorder actions within a group
 */
export const useReorderActions = () => {
  const queryClient = useQueryClient();

  return useMutation<IReorderActionsResponse, Error, IReorderActionsRequest>({
    mutationFn: reorderActions,
    onSuccess: (_, variables) => {
      // Invalidate compass chat history to reflect new order
      queryClient.invalidateQueries({
        queryKey: ["compass-chat-history", variables.context_id],
      });
    },
    onError: (error) => {
      console.error("Failed to reorder actions:", error);
    },
  });
};
